import { useState, useEffect } from 'react';
import { ReactComponent as ProfilePicture } from '@Assets/blankProfile.svg';
import { MdPerson as PersonIcon } from 'react-icons/md';
import LinearProgress from '@mui/material/LinearProgress';
import Box from '@mui/material/Box';
import ProfileView from '@CommonViews/ProfileView';
import UserInfoService from '@Helpers/URLHelpers/UserInfoService';
import ErrorHandler from '@Root/ErrorHandler';
import './UserProjectTeamStatsRow.scss';

export default function UserProjectTeamStatsRow(props) {
    const [progress, setProgress] = useState(0);
    const [showProfileView, setShowProfileView] = useState(false);
    const [profileId, setProfileId] = useState(0);
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const userInfoService = new UserInfoService();
    const errorHandler = new ErrorHandler();
    const className = 'userProjectTeamStatsRow';

    useEffect(() => {
        if (props?.userAnalysis?.userId) {
            loadUserData();
            parseData();
        }
    }, [props]);

    const loadUserData = async () => {
        try {
            setLoading(true);
            let userObj = await userInfoService.getUserById(props?.userAnalysis?.userId);
            userObj = JSON.parse(userObj.body);
            setUser(userObj);
        } catch (err) {
            errorHandler.handleError(err);
        } finally {
            setLoading(false);
        }
    };

    const parseData = () => {
        let progressValue = (props?.userAnalysis?.doneItems / (props?.userAnalysis?.openItems + props?.userAnalysis?.doneItems));
        if (isNaN(progressValue)) progressValue = 0;
        progressValue = progressValue.toFixed(2);
        setProgress(progressValue * 100);
    };

    const handleUserClick = () => {
        setProfileId(props?.userAnalysis?.userId);
        toggleProfileView();
    };

    const toggleProfileView = () => {
        setShowProfileView(!showProfileView);
    };

    const dataURLtoFile = (dataurl) => {
        var arr = dataurl.split(','),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]),
            n = bstr.length,
            u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], { type: mime });
    };

    const openItems = props?.userAnalysis?.openItems || 0;
    const doneItems = props?.userAnalysis?.doneItems || 0;
    const total = openItems + doneItems;

    if (loading) {
        return (
            <div className={`${className} loading`}>
                <div className={`${className}__skeleton`}>
                    <div className={`${className}__skeleton__avatar`}></div>
                    <div className={`${className}__skeleton__content`}>
                        <div className={`${className}__skeleton__name`}></div>
                        <div className={`${className}__skeleton__bar`}></div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <>
            <div className={className} onClick={handleUserClick}>
                <div className={`${className}__left`}>
                    <div className={`${className}__avatar`}>
                        {user?.photo !== undefined && user?.photo !== 'null' ? (
                            <img src={URL.createObjectURL(dataURLtoFile(user?.photo))} alt='Profile' />
                        ) : (
                            <PersonIcon />
                        )}
                    </div>
                    <div className={`${className}__info`}>
                        <div className={`${className}__name`}>{user?.fullName}</div>
                        <div className={`${className}__username`}>@{user?.userName}</div>
                    </div>
                </div>
                <div className={`${className}__right`}>
                    <div className={`${className}__progress`}>
                        <Box sx={{ width: '100%' }}>
                            <LinearProgress
                                variant="determinate"
                                value={progress}
                                sx={{
                                    height: 8,
                                    borderRadius: 4,
                                    '& .MuiLinearProgress-bar': {
                                        borderRadius: 4,
                                        backgroundColor: progress === 100 ? '#4caf50' : 'var(--color-primaryBlue)'
                                    },
                                    backgroundColor: 'var(--color-border)'
                                }}
                            />
                        </Box>
                        <div className={`${className}__stats`}>
                            <span className={`${className}__percentage`}>{Math.round(progress)}%</span>
                            <span className={`${className}__count`}>{doneItems}/{total}</span>
                        </div>
                    </div>
                </div>
            </div>
            {showProfileView && (
                <ProfileView
                    open={showProfileView}
                    closePopup={toggleProfileView}
                    profileId={profileId}
                />
            )}
        </>
    );
}
